import styled from 'styled-components';

export const Checkbox = styled.span`
  display: inline-flex;
  position: relative;
  min-height: 2rem;

  [type='checkbox'] {
    position: absolute;
    left: -9999px;
    opacity: 0;
  }

  label {
    position: relative;
    padding-left: 2.4rem;
    cursor: pointer;
    font-size: 1.4rem;
    line-height: 2rem;
    color: #4f525a;
  }

  label.labelWithIcon {
    display: inline-flex;
  }

  label:before {
    content: '';
    width: 1.8rem;
    height: 1.8rem;
    position: absolute;
    left: 0;
    top: 0.2rem;
    border-radius: 0.2rem;
    background-color: #fff;
    border: 0.2rem solid #647a97;
  }

  [type='checkbox']:checked + label:before {
    border: 0.1rem solid #2276e3;
    background-color: #2276e3;
  }

  [type='checkbox']:checked + label:after {
    content: '';
    width: 0.6rem;
    height: 1rem;
    position: absolute;
    left: 0.6rem;
    top: 0.4rem;
    display: block;
    border: solid #fff;
    border-width: 0 0.2rem 0.2rem 0;
    transform: rotate(45deg);
    transition: all 0.2s ease;
  }

  &.disabled {
    background: #eee;
    color: #666;
  }
`;

